// extracted by mini-css-extract-plugin
export default {"body":"WalletLockedModal_body__+fjb3"};